define('views/modules/profile/edit/custom-message-edit-panel',[
    // Libs
    'underscore', 'utils',
    // models
    'models/conversation/custom-message',
    // views
    'views/parts/panel/base-panel',
    'views/modules/profile/edit/custom-message-edit-content'
], function(
    // Libs
    _, U,
    // models
    MCustomMessage,
    // views
    VBasePanel,
    VCustomMessageEditContent
) {

    var VCustomMessageEditPanel = VBasePanel.extend({
        header: {
            title: "Personal settings",
            subtitle: "Customize your own Totalcoaching",
        },
        content: { edit: VCustomMessageEditContent },
        tabs: [{
            id: 'edit',
            title: 'conversation:Custom message edit',
            active: true }],
        defaultView: 'edit',

        initialize: function(opt) {
            this.model = new MCustomMessage();
            var edit = this.getView('edit', { model: this.model });
            this.listenTo(edit, 'form:success', this.onSuccess);
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
            this.close();
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            this.model.fetch();
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

    });

    return VCustomMessageEditPanel;
});

